import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="httprequest">
                1.&nbsp;<span className="material-symbols-outlined">http</span>&nbsp;{translate('httprequest')}
            </Typography>
            <p><strong>{translate('httprequest')}</strong> is an action that sends an HTTP request.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$httpRequest_1</td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the URL of the request.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('method')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the request method (including: GET, POST, PUT, PATCH, DELETE).</td>
                                <td>GET</td>
                            </tr>
                            <tr>
                                <td>{translate('headers')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is part of the Hypertext Transfer Protocol (HTTP) and transmits additional information in requests.</td>
                                <td>{`{"Content-Type": "application/json"}`}</td>
                            </tr>
                            <tr>
                                <td>{translate('params')}</td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>As a query parameter.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$httpRequest_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://zipcloud.ibsnet.co.jp/api/search</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('method')}</span>
                            <div>GET</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('headers')}</span>
                            <div>{`{"Content-Type": "application/json"}`}</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('params')}</span>
                            <div>{`{"zipcode": "7830060"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "message": null,
                                            "results": [
                                                {
                                                "address1": "高知県",
                                                "address2": "南国市",
                                                "address3": "蛍が丘",
                                                "kana1": "ｺｳﾁｹﾝ",
                                                "kana2": "ﾅﾝｺｸｼ",
                                                "kana3": "ﾎﾀﾙｶﾞｵｶ",
                                                "prefcode": "39",
                                                "zipcode": "7830060"
                                                }
                                            ],
                                            "status": 200
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getfilefromurl">
                2.&nbsp;<span className="material-symbols-outlined">imagesmode</span>&nbsp;{translate('getfilefromurl')}
            </Typography>
            <p><strong>{translate('getfilefromurl')}</strong> is an action that downloads a file from a URL.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$getFileFromUrl_1</td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the URL of the file to download.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthusername')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the basic authentication login name.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthpassword')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the basic authentication password.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$getFileFromUrl_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/googlelogo_color_272x92dp.png</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);